import PropTypes from 'prop-types'
import { Badge, Button } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import ProductStatusBadge from 'domains/product/atoms/product-status-badge/product-status-badge'
import InStockBadge from 'domains/product/atoms/in-stock-badge/in-stock-badge'
const propTypes = {
  product           : PropTypes.object,
  handleClickRemove : PropTypes.func
}

const defaultProps = {
  discountBatch     : {},
  handleClickRemove : () => {}
}

const ProductDiscountTableRow = ({
  product,
  handleClickRemove
}) => {
  const StatusCell  = (value) => <ProductStatusBadge product_status={ value } />
  const InStockCell = (value) => <InStockBadge is_in_stock={ value } />

  let disableReasons          = []
  const status                = product.status
  const isInStock             = product.is_in_stock
  const isNewPriceHigher      = product.new_selling_price >= product.selling_price
  const isMarketingDiscounted = product.is_marketing_discount

  if (status == 'disabled') disableReasons.push('Product is disabled')
  if (!isInStock ) disableReasons.push('Out of Stock')
  if (isNewPriceHigher) disableReasons.push('New Price same or higher than current Selling Price')
  if (isMarketingDiscounted) disableReasons.push('Product is already discounted by marketing')

  return (
    <tr className={ product.is_eligible ? null : 'table-warning' }>
      <td className='text-center align-middle'>
        <div>
          <Badge color='primary'>{ product.productable_type }</Badge>
          <div>{ product.sku }</div>
        </div>
      </td>
      <td className='align-middle'>
        { StatusCell(status) }
      </td>
      <td className='align-middle'>
        { InStockCell(isInStock) }
      </td>
      <td className='align-middle'>
        { PriceUtil.format(product.selling_price) }
      </td>
      <td className='align-middle'>
        { PriceUtil.format(product.new_selling_price) }
      </td>
      <td
        className='align-middle font-weight-bolder text-wrap'
      >
        <ul className='pl-3'>
          {
            disableReasons.length > 0 &&
            disableReasons.map((disableReason,index) => (
              <li key={ `DisableReason-${index}` }>
                { disableReason }
              </li>
            )) }
        </ul>
      </td>
      <td className="text-center bd-highlight align-middle">
        <Button
          size='sm'
          color='danger'
          className= 'align-self-center'
          onClick={ () => handleClickRemove(product.id) }
        >
          { 'Remove' }
        </Button>
      </td>
    </tr>
  )
}

ProductDiscountTableRow.propTypes    = propTypes
ProductDiscountTableRow.defaultProps = defaultProps


export default ProductDiscountTableRow